import StoresFilter from './StoresFilter';

export default StoresFilter;
